const initialState = {
  shippingCountries: []
};

const shippingCountries = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default shippingCountries;
